export const stripeConstants = {
  GET_CONNECT_URL_REQUEST: 'GET_CONNECT_URL_REQUEST',
  GET_CONNECT_URL_SUCCESS: 'GET_CONNECT_URL_SUCCESS',
  GET_CONNECT_URL_FAILURE: 'GET_CONNECT_URL_FAILURE',

  GET_CONNECT_ID_REQUEST: 'GET_CONNECT_ID_REQUEST',
  GET_CONNECT_ID_SUCCESS: 'GET_CONNECT_ID_SUCCESS',
  GET_CONNECT_ID_FAILURE: 'GET_CONNECT_ID_FAILURE',

  GET_CUSTOMER_ID_REQUEST: 'GET_CUSTOMER_ID_REQUEST',
  GET_CUSTOMER_ID_SUCCESS: 'GET_CUSTOMER_ID_SUCCESS',
  GET_CUSTOMER_ID_FAILURE: 'GET_CUSTOMER_ID_FAILURE',

  RETRIEVE_SOURCES_REQUEST: 'RETRIEVE_SOURCES_REQUEST',
  RETRIEVE_SOURCES_SUCCESS: 'RETRIEVE_SOURCES_SUCCESS',
  RETRIEVE_SOURCES_FAILURE: 'RETRIEVE_SOURCES_FAILURE',

  REGISTER_PAYOUT_ACCOUNT_REQUEST: 'REGISTER_PAYOUT_ACCOUNT_REQUEST',
  REGISTER_PAYOUT_ACCOUNT_SUCCESS: 'REGISTER_PAYOUT_ACCOUNT_SUCCESS',
  REGISTER_PAYOUT_ACCOUNT_FAILURE: 'REGISTER_PAYOUT_ACCOUNT_FAILURE',

  SOURCE_ACTION_REQUEST: 'SOURCE_ACTION_REQUEST',
  SOURCE_ACTION_SUCCESS: 'SOURCE_ACTION_SUCCESS',
  SOURCE_ACTION_FAILURE: 'SOURCE_ACTION_FAILURE',

  CREATE_CUSTOMER_REQUEST: 'CREATE_CUSTOMER_REQUEST',
  CREATE_CUSTOMER_SUCCESS: 'CREATE_CUSTOMER_SUCCESS',
  CREATE_CUSTOMER_FAILURE: 'CREATE_CUSTOMER_FAILURE',

  RETRIEVE_ACCOUNTLINK_REQUEST: 'RETRIEVE_ACCOUNTLINK_REQUEST',
  RETRIEVE_ACCOUNTLINK_SUCCESS: 'RETRIEVE_ACCOUNTLINK_SUCCESS',
  RETRIEVE_ACCOUNTLINK_FAILURE: 'RETRIEVE_ACCOUNTLINK_FAILURE',

}


export const STRIPE_LIGHT_CARD_OPTIONS = {
  iconStyle: 'solid',
  style: {
    base: {
      fontSize: '16px',
      color: '#282828',
      iconColor: "#282828",
      fontFamily: 'Open Sans, sans-serif',
      fontSmoothing: "antialiased",
      letterSpacing: '0.025em',
      '::placeholder': {
        color: '#8898aa',
      },
      ':-webkit-autofill': {
        color: '#282828',
      },
    },
    invalid: {
      color: '#FFC7EE',
      iconColor: "#FFC7EE",
    },
  },
};

export const STRIPE_DARK_CARD_OPTIONS = {
  iconStyle: 'solid',
  style: {
    base: {
      fontSize: '16px',
      color: '#e0e0e0',              // Light text for dark background
      iconColor: '#e0e0e0',
      fontFamily: 'Open Sans, sans-serif',
      fontSmoothing: 'antialiased',
      letterSpacing: '0.025em',
      '::placeholder': {
        color: '#a0a0a0',            // Dimmed placeholder
      },
      ':-webkit-autofill': {
        color: '#e0e0e0',
      },
    },
    invalid: {
      color: '#FF4F83',              // Bright error pink
      iconColor: '#FF4F83',
    },
  },
};

export const STRIPE_EXPRESS_CHECKOUT_OPTIONS = {
  layout: 'auto',
  buttonType: {
    googlePay: 'buy',
    applePay: 'buy',
    paypal: 'buynow',
  },
  buttonTheme: {
    applePay: 'black'
  },
  buttonHeight: 55
}

// _constants/stripeAppearance.js

export const STRIPE_PAYMENT_ELEMENT_LIGHT = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#FF4F83',
    colorText: '#282828',
    colorBackground: '#ffffff',
    colorDanger: '#FFC7EE',
    fontFamily: 'Open Sans, sans-serif',
    fontSizeBase: '16px',
    spacingUnit: '6px',
    borderRadius: '8px',
  },
  rules: {
    '.Label, .TabLabel': {
      fontSize: '0.625rem',
      textTransform: 'uppercase',
      fontWeight: '600',
      letterSpacing: '2px',
      color: '#8898aa',
      marginBottom: '4px',
    },
    '.Input': {
      border: '1px solid #dcdcdc',
      borderRadius: '8px',
      padding: '12px 14px',
      color: '#282828',
      fontFamily: 'Open Sans, sans-serif',
      fontSize: '16px',
      letterSpacing: '0.025em',
    },
    '.Input::placeholder': {
      color: '#8898aa',
    },
    '.Input:focus': {
      borderColor: '#FF4F83',
      boxShadow: '0 0 0 1px #FF4F83',
    },
  },
};

export const STRIPE_PAYMENT_ELEMENT_DARK = {
  theme: 'night',
  variables: {
    colorPrimary: '#FF4F83',
    colorText: '#fff',
    colorBackground: '#181818',
    colorDanger: '#FF4F83',
    fontFamily: 'Open Sans, sans-serif',
    fontSizeBase: '16px',
    spacingUnit: '6px',
    borderRadius: '8px',
  },
  rules: {
    '.Label, .TabLabel': {
      fontSize: '0.625rem',
      textTransform: 'uppercase',
      fontWeight: '600',
      letterSpacing: '2px',
      color: '#e9ecef',
      marginBottom: '4px',
    },
    '.Input': {
      border: '1px solid #2c2c2c',
      borderRadius: '8px',
      backgroundColor: '#202020',
      color: '#fff',
      padding: '12px 14px',
      fontFamily: 'Open Sans, sans-serif',
      fontSize: '16px',
      letterSpacing: '2px',
    },
    '.Input::placeholder': {
      color: '#a0a0a0',
    },
    '.Input:focus': {
      borderColor: '#FF4F83',
      boxShadow: '0 0 0 1px #FF4F83',
    },
  },
};